import { render, staticRenderFns } from "./scenarioDescription.vue?vue&type=template&id=3a9a52a2"
import script from "./scenarioDescription.vue?vue&type=script&lang=js"
export * from "./scenarioDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./scenarioDescription.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports